import i18n from "../i18n";

const ROLE_KEYS = {
  "Süper Admin": "roles.superAdmin",
  Öğretmen: "roles.teacher",
  Öğrenci: "roles.student",
  Koordinatör: "roles.coordinator",
};

export const translateRole = (role) => {
  const key = ROLE_KEYS[role];
  return key ? i18n.t(key) : role;
};
